/**
 * videojs-cta
 * @version 0.0.0
 * @copyright 2019 ameni bouattour
 * @license MIT
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.videojsCta = factory());
}(this, (function () { 'use strict';

var version = "0.0.0";

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  var structure = options;
  var _content;
  var htmlStructure;
  if (structure.selected === "text" || structure.selected === "pdf") {
    if (structure.link) {
      htmlStructure = "<p>\n      <a href='//" + structure.link + "' target=\"_blank\">" + structure.text + "</a>\n      </p>";
    } else {
      htmlStructure = "<p>" + structure.text + "</p>";
    }
    if (structure.selected === "pdf") {
      htmlStructure += "<p>\n        <small class=\"pdf-link\">\n          <a href='" + structure.filePath + "' target=\"_blank\">\n            Consulter le pdf\n            <img src=\"data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDI2IDI2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNiAyNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiPgo8Zz4KCTxwYXRoIGQ9Ik0xOCwxNy43NTl2My4zNjZDMTgsMjIuMTU5LDE3LjE1OSwyMywxNi4xMjUsMjNINC44NzVDMy44NDEsMjMsMywyMi4xNTksMywyMS4xMjVWOS44NzUgICBDMyw4Ljg0MSwzLjg0MSw4LDQuODc1LDhoMy40MjlsMy4wMDEtM2gtNi40M0MyLjE4Miw1LDAsNy4xODIsMCw5Ljg3NXYxMS4yNUMwLDIzLjgxOCwyLjE4MiwyNiw0Ljg3NSwyNmgxMS4yNSAgIEMxOC44MTgsMjYsMjEsMjMuODE4LDIxLDIxLjEyNXYtNi4zNjdMMTgsMTcuNzU5eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPGc+CgkJPHBhdGggZD0iTTIyLjU4MSwwSDEyLjMyMmMtMS44ODYsMC4wMDItMS43NTUsMC41MS0wLjc2LDEuNTA0bDMuMjIsMy4yMmwtNS41Miw1LjUxOSAgICBjLTEuMTQ1LDEuMTQ0LTEuMTQ0LDIuOTk4LDAsNC4xNDFsMi40MSwyLjQxMWMxLjE0NCwxLjE0MSwyLjk5NiwxLjE0Miw0LjE0LTAuMDAxbDUuNTItNS41MmwzLjE2LDMuMTYgICAgYzEuMTAxLDEuMSwxLjUwNywxLjEyOSwxLjUwNy0wLjc1N0wyNiwzLjQxOUMyNS45OTktMC4wMTgsMjYuMDI0LTAuMDAxLDIyLjU4MSwweiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=\" alt=\"\">\n          </a>\n        </small>\n      </p>\n    ";
    }
  } else if (structure.selected === "image") {
    htmlStructure = "\n  <a href='//" + structure.link + "' target=\"_blank\"><img src=\"" + structure.imagePath + "\"></a>\n  ";
  } else {
    return;
  }
  /**
   * Generate the DOM elements for the suggested video endcap content
   * @type {function}
   */
  function constructContent() {
    var _frag = document.createDocumentFragment();
    var _aside = document.createElement('aside');

    _aside.className = 'vjs-endcapCTA';
    _aside.innerHTML = htmlStructure;

    _content = _aside;
    _frag.appendChild(_aside);
    player.el().appendChild(_frag);
  }

  // attach VideoJS event handlers
  player.on('ended', function () {
    _content.classList.add('is-active');
    if (options.run) options.run();
    player.bigPlayButton.hide();
    player.controlBar.hide();
  });
  player.on('play', function () {
    if (_content) {
      _content.classList.remove('is-active');
      player.bigPlayButton.show();
      player.controlBar.show();
    }
  });
  player.ready(function () {
    constructContent();
  });
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function cta
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var cta = function cta(options) {
  var _this = this;

  this.ready(function () {
    onPlayerReady(_this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin('cta', cta);

// Include the version number.
cta.VERSION = version;

return cta;

})));



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_cta/dist/videojs-cta.js
// module id = 624
// module chunks = 0